import axios, { AxiosResponse } from 'axios';
import { ID } from 'types';

interface LineItemSearchParams {
  bidRequestId: ID;
  searchTerm: string;
}

export const lineItemSearch = async ({ searchTerm, bidRequestId }: LineItemSearchParams): Promise<AxiosResponse> => {
  const url = `/api/v1/events/${bidRequestId}/line_items?search=${searchTerm}`;

  return axios.get(url);
};
